import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChangePasswordAuthUserComponent } from './change-password-auth-user/change-password-auth-user.component';

import { USER_PATHS } from './user';

import { AuthGuard } from '../auth/auth.guard.service';

export const routes: Routes = [
  {
    path: USER_PATHS.change_password_auth_user,
    canActivate: [AuthGuard],
    component: ChangePasswordAuthUserComponent,
    data: { animation: 'ChangeUserPasswordPage' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UserRoutingModule {}
